import { BusinessUnitForm } from "@/types/businessunit.type";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function Rooms() {
  const { t } = useTranslation()
  const { register, control, formState: {errors} } = useFormContext<BusinessUnitForm>()
  const {fields, append, remove} = useFieldArray({
    control,
    name: "rooms",
    keyName: "key_room"
  })

  return (
    <div className="mb-4">
      <div className="flex justify-between">
        <p className="mb-1 block text-black dark:text-white text-lg">
          {t("businessunit.rooms")}
        </p>
        <button type="button" className="rounded bg-primary ms-3 h-6 px-2 text-white" onClick={() => append({code: "", name: "", business_unit_id: ""})}>
          <i className="fa-light fa-plus me-1"></i>
          {t("form.add")}
        </button>
      </div>
      {
        fields.map((room, index) => {
          return (
            <div className="flex mb-2" key={room.key_room}>
              <div className="grow me-10">
                {
                  index === 0 &&  <label className="mb-1 block text-black dark:text-white">
                    {t("businessunit.room_number")}
                  </label>
                }
                <input
                  type="text"
                  placeholder={t(`placeholder.room_number`, { index: index+1, interpolation: { escapeValue: false } })}
                  className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  {...register(`rooms.${index}.code`, { required: t("validation.required") })}
                />
                { errors.rooms && errors.rooms[index] && <p className="mt-1 text-rose-600">{errors.rooms[index]?.code?.message || ""}</p>}
              </div>
              <div className="grow">
                {
                  index === 0 &&  <label className="mb-1 block text-black dark:text-white">
                    {t("dashboard.room_type")}
                  </label>
                }
                <div className="flex items-start">
                  <div className="grow">
                    <input
                      type="text"
                      placeholder={t(`placeholder.room_type`, { index: index+1, interpolation: { escapeValue: false } })}
                      className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                      {...register(`rooms.${index}.name`)}
                    />
                  </div>
                  {
                    fields.length > 1 && <div className="flex items-center">
                      <button type="button" className="rounded bg-danger ms-3 h-8 w-8 text-white hover:bg-opacity-90" onClick={() => remove(index)}>
                        <i className="fa-sharp fa-light fa-trash-can" />
                      </button>
                    </div>
                  }
                </div>
              </div>
              
             
            </div>
          )
        })
      }
    </div>
  )
}